module.exports = __webpack_public_path__ + "static/media/0022_LES_ENSEIGNES_LE_TRAITEUR_LETTRE_A_LETTRE.e7210fd8.webp";